import type { RoomSnapshot } from "../models/contracts";

const partyTypeLabel = (value: string) => value
  .trim()
  .replace(/[-_]+/g, " ")
  .replace(/\b\w/g, (character) => character.toUpperCase());

export function PartyIdentity({ party, compact = false }: { party: RoomSnapshot; compact?: boolean }) {
  const eyebrow = party.room.flowMode === "FreeFlow"
    ? "Free Flow"
    : party.currentMoment?.displayName ?? partyTypeLabel(party.room.partyType);
  return <div class={compact ? "party-identity compact" : "party-identity"}><span class="eyebrow">{eyebrow}</span><h1 dir="auto">{party.room.title}</h1></div>;
}
